import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { HeaderAndNavigationService } from '../headerandnavigation/headerandnavigation.service';

@Component({
  templateUrl: "./myfleetsolutions.new.component.html"
})
export class MyFleetSolutionsNewComponent implements OnInit, AfterViewInit {
  public pageTitle: string = 'My Fleet Solutions';
  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public headerAndNavigationService: HeaderAndNavigationService,
  ) {
    this.appCommonService.pageName = this.pageTitle;
    this.appCommonService.pageContentAdditionalClass = "dashboard-page";
  }
  ngOnInit() {
    this.headerAndNavigationService.showhideNav(true, false);
  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/home/myfleetsolutions.new.component.ts